import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import getCardStatements from "../../common/getCardStatements";

export const getCardStatement = createAsyncThunk(
	"user/CardStatement",
	async (params, { getState }) => {
		const state = getState();

		try {
			let CardStatement = await getCardStatements(
				state.Login.Auth.session_token,
				params
			);

			return CardStatement.data.data;
		} catch (e) {
			if (e.data.error) {
				console.log(e.data.data.error);
			}
			console.log("Error:::", e);
			return e?.message;
		}
	}
);

const initialState = {
	Statements: [],
	loading: true,
};

export const CardStatementSlice = createSlice({
	name: "UserCardStatement",
	initialState,
	reducers: {
		setCardStatement: (state, action) => {
			state.CardStatement = action.payload;
		},
	},
	extraReducers: {
		[getCardStatement.pending]: (state, action) => {
			state.loading = true;
		},
		[getCardStatement.fulfilled]: (state, action) => {
			state.Statements = action.payload;
			state.loading = false;
		},
		[getCardStatement.rejected]: (state, action) => {
			state.Statements = [];
			state.error = action.payload;
			state.loading = false;
		},
	},
});

export const { setCardStatement } = CardStatementSlice.actions;

export default CardStatementSlice.reducer;
